import { motion } from "framer-motion";
import {
  ClipboardCheck,
  FileText,
  Tags,
  UserCheck,
} from "lucide-react";

export const FeaturesSection = () => {
  const features = [
    {
      icon: ClipboardCheck,
      title: "Weekly snapshot",
      description:
        "What you sold, what you spent on, and what you made every week. Wake up Monday morning and know where you stand.",
    },
    {
      icon: FileText,
      title: "Receipt processing & cost tracking",
      description:
        "Set up auto-forwarding once. Every receipt is read, categorized, and tracked — so your food costs stay up to date and nothing moves without you seeing it.",
    },
    {
      icon: Tags,
      title: "Menu & Platform Profitability",
      description:
        "See which items actually make you money, whether your prices are right across every platform, and which platforms are worth being on.",
    },
    {
      icon: UserCheck,
      title: "Bill works for you",
      description:
        "No digging through numbers. Bill watches everything, spots what's off, and tells you exactly what to adjust — in plain English, before it costs you.",
    },
  ];

  return (
    <section id="features" className="py-24 px-6 bg-stone">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-midnight tracking-tight">
            Clear numbers. <span className="text-vault-green">Every week.</span>
          </h2>
          <p className="text-lg text-slate-brand max-w-2xl mx-auto">
            Less time buried in spreadsheets. More time for what actually matters.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              whileHover={{ y: -4 }}
              className="bg-white rounded-xl p-7 border border-fog hover:border-vault-green/30 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-vault-green/10 flex items-center justify-center mb-5">
                <feature.icon className="w-6 h-6 text-vault-green" />
              </div>
              <h3 className="text-lg font-bold mb-2 text-midnight">
                {feature.title}
              </h3>
              <p className="text-slate-brand text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
